import { toast } from "react-toastify";

import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import { HTTPError } from "common/helpers/HTTP";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface AssignLicenseProps {
  accountId: string;
  accountFullname: string;
  goBack: () => void;
  onSuccess: () => void;
}

export default function AssignLicense({
  accountId,
  accountFullname,
  goBack,
  onSuccess,
}: AssignLicenseProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { assignLicense, isAssigningLicense } = useLicenseMutations();

  function onAssign() {
    assignLicense({ accountId })
      .then(onSuccess)
      .catch((error) => {
        toast.error(
          error instanceof HTTPError && error.serverMessage
            ? error.serverMessage
            : "Failed to assign seat",
        );
      });
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title={<>Assign seat to "{accountFullname}"?</>}
        subtitle="You will get full access to LinkedIn Outreach and campaigns"
      />

      <Footer className="justify-end">
        <Button
          onClick={goBack}
          variant="secondary-black"
          disabled={isAssigningLicense}
        >
          Cancel
        </Button>
        <Button
          isLoading={isAssigningLicense}
          onClick={onAssign}
          variant="gradient"
        >
          Assign
        </Button>
      </Footer>
    </>
  );
}
